import { format } from 'date-fns'

export const setDateValue = (formik, field, date) => {
  if (date) {
    formik.setFieldValue(field, format(date, 'dd.MM.yyyy'))
  } else {
    formik.setFieldValue(field, null)
  }
}
